(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("modal", [], factory);
	else if(typeof exports === 'object')
		exports["modal"] = factory();
	else
		root["modal"] = factory();
})(this, function() {
return 